import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase konfigurace - pouze pro Realtime Database (otázky)
const firebaseConfig = {
  databaseURL: "https://synapsoquestions-default-rtdb.europe-west1.firebasedatabase.app"
};

// Inicializace Firebase
const app = initializeApp(firebaseConfig);

// Export databáze
export const database = getDatabase(app);
